import apiClient from '@/services/axios'

export async function post(venueCampaignId) {
  var response = await apiClient.post(process.env.VUE_APP_CRM_API_BASE_URL + '/VenueCampaigns/SubmitForApproval', { venueCampaignId })
  if (response) {
    return response.data
  }

  throw new Error('Unable to get venue campaigns')
}
